<template>
  <div class="TestPaperList">
    <div class="tableFilter">
      <el-form :inline="true" :model="filter" size="small" ref="form">
        <el-form-item label="创建时间">
          <el-date-picker
              style="width: 250px"
              v-model="filter.dateRange"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSubmit"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
              v-model="filter.keyword"
              placeholder="试卷名称"
              @keyup.enter.native="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查找</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <input
            type="file"
            ref="fileInput"
            style="display: none"
            @change="handleFileChange"
        />
        <el-button
            type="primary"
            native-type="submit"
            plain
            @click="openCreateTestPaper"
            v-show="permissionCode.has('plugin:testPaper:manager')"
        >生成试卷
        </el-button>
        <el-button
            type="primary"
            native-type="submit"
            plain
            @click="openTestPaperEditor"
            v-show="permissionCode.has('plugin:testPaper:manager')"
        >新增试卷
        </el-button>
        <el-button
            type="primary"
            native-type="submit"
            plain
            @click="openFilePicker" v-show="permissionCode.has('plugin:testPaper:manager')"
        >导入试卷
        </el-button>
        <el-button
            type="primary"
            native-type="submit"
            plain
            @click="handleDownLoad" v-show="permissionCode.has('plugin:testPaper:manager')"
        >下载模板
        </el-button>
      </div>
    </div>
    <XTable
        :api="getTestPaperList"
        :state="testPaperList"
        :columns="columns"
        :loading="testPaperListLoading"
        :tableSize="tableSize"
        :firstColumn="firstColumn"
        :layout="layout"
        :maxHeight="maxHeight"
    ></XTable>
    <AddTestPaperModal ref="testPaperEditor"></AddTestPaperModal>
    <el-dialog title="微信二维码" :visible.sync="qrCodeVisible" style="text-align: center">
      <el-image :src="qrcodeImage">
        <!--        <div slot="error" class="image-slot">-->
        <!--          <i style="font-size: 400px;" class="el-icon-picture-outline"></i>-->
        <!--        </div>-->
      </el-image>
    </el-dialog>
    <CreateTestPaperModal @created="testPaperCreated" ref="createTestPaperModal"></CreateTestPaperModal>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import AddTestPaperModal from "@/pages/QuestionBank/AddTestPaperModal.vue";
import {wxEnv} from "@/helpers/request";
import Base64 from "@/utils/base64";
import CreateTestPaperModal from "@/pages/QuestionBank/CreateTestPaperModal.vue";

export default {
  name: "TestPaperList",
  components: {CreateTestPaperModal, AddTestPaperModal, XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: false,
      qrCodeVisible: false,
      qrcodeImage: ""
    };
  },
  computed: {
    ...mapState("pluginCenter", ["testPaperList", "testPaperListLoading", "testQuestionListFilter", "testQuestionList"]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.pluginCenter.testPaperListFilter;
      },
      set(value) {
        this.$store.commit("pluginCenter/setData", {
          key: "testPaperListFilter",
          value,
        });
      },
    },
    columns() {
      const self = this;
      const columns = [
        {
          prop: "id",
          label: "ID",
          width: 100,
        },
        {
          prop: "name",
          label: "试卷名称",
        },
        {
          prop: "testQuestionCount",
          label: "试题数",
          width: 100,
        },
        {
          label: "是否上架",
          width: 100,
          render(h, scope) {
            return (
                <div>
                  <span>{scope.row.deployed ? "已上架" : "已下架"}</span>
                </div>
            );
          },
        },
        {
          label: "创建日期",
          width: 100,
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.createTime)}</span>
                </div>
            );
          },
        },
      ];

      return [
        ...columns,
        {
          label: "操作",
          fixed: "right",
          render(h, scope) {
            let canEdite = self.permissionCode.has('plugin:testPaper:manager');
            return (
                <div>
                  {
                    <el-button
                        onClick={() => {
                          self.viewTestQuestionList(scope.row);
                        }}
                        size="mini"
                        type="primary"
                        plain
                    >
                      查看试题
                    </el-button>
                  }
                  {
                    <el-button
                        onClick={() => {
                          self.viewTestQuestionReport(scope.row);
                        }}
                        size="mini"
                        type="primary"
                        plain
                    >
                      测试报告
                    </el-button>
                  }
                  {scope.row.deployed &&
                      <el-button
                          onClick={() => {
                            self.handleGenerateQRCode(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        微信二维码
                      </el-button>
                  }
                  {canEdite && !scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.handleDeploy(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        {scope.row.deployed ? "下架" : "上架"}
                      </el-button>)
                  }
                  {canEdite && !scope.row.noEdit && (
                      <el-button
                          onClick={() => {
                            self.openTestPaperEditor(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        编辑
                      </el-button>)
                  }
                  {canEdite && !scope.row.noEdit &&
                      <el-button
                          onClick={() => {
                            self.handleDelete(scope.row);
                          }}
                          size="mini"
                          type="danger"
                          plain
                      >
                        删除
                      </el-button>
                  }
                </div>
            );
          },
        }
      ];
    }
  },
  methods: {
    ...mapActions("pluginCenter", [
      "getTestPaperList",
      "importTestPaper",
      "deleteTestPaper",
      "deployTestPaper",
      "generateQRCode"
    ]),
    ...mapMutations("pluginCenter", ["clearFilter", "setData"]),
    testPaperCreated() {
      this.getTestPaperList({})
    },
    openCreateTestPaper() {
      this.$refs.createTestPaperModal.visible = true;
    },
    async handleGenerateQRCode(row) {
      this.qrcodeImage = null;
      let scene = "examId=" + row.id + "&questionCnt=" + row.testQuestionCount;
      let data = await this.generateQRCode({
        page: "exam/questionBank/test/test",
        scene: scene,
        checkPath: true,
        width: 480,
        envVersion: wxEnv
      });
      let blob = new Blob([data], {type: 'image/jpeg'});
      this.qrcodeImage = window.URL.createObjectURL(blob);
      this.qrCodeVisible = true;
    },
    openTestPaperEditor(row) {
      this.$refs.testPaperEditor.initFormData(row)
      this.$refs.testPaperEditor.visible = true;
    },
    viewTestQuestionList(row) {
      this.setData({key: "activeTab", value: "1"});
      this.testQuestionListFilter.testPaperId = row.id;
      this.testQuestionList.page = 1;
    },
    viewTestQuestionReport(row) {
      this.$router.push({name: "TestPaperReport", params: {testPaperId: Base64.encode(row.id)}})
    },
    async handleDeploy(row) {
      await this.deployTestPaper({id: row.id})
      await this.getTestPaperList({});
    },
    async onSubmit() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getTestPaperList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    async onReset() {
      await this.clearFilter();
      await this.getTestPaperList({
        page: 1,
      });
    },
    openFilePicker() {
      // 点击按钮时触发 input[type="file"] 的点击事件
      this.$refs.fileInput.click();
    },
    // 下载模板
    handleDownLoad() {
      var eleLink = document.createElement("a");
      eleLink.download = "题库模板";
      eleLink.style.display = "none";

      // 字符内容转变成blob地址
      eleLink.href =
          "https://jy-static-public.oss-cn-shanghai.aliyuncs.com/static/web/template/%E9%A2%98%E5%BA%93%E6%A8%A1%E7%89%88.xls";
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
    },
    async handleFileChange(event) {
      let file = event.target.files[0];
      // 处理选择的文件
      if (file.name.endsWith(".xls") || file.name.endsWith(".xlsx")) {
        const data = new FormData();
        data.append("file", file);
        await this.importTestPaper(data);
        await this.getTestPaperList({
          page: this.testPaperList.page,
          size: this.testPaperList.size,
        });
        this.$message.warning("导入成功");
      } else {
        this.$message.warning("请选择Excel文件进行导入");
      }
      file = null;
    },
    async handleDelete(row) {
      this.$confirm("删除后不可找回,请确认是否要删除改试卷!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await this.deleteTestPaper({id: row.id});
        await this.getTestPaperList({
          page: this.testPaperList.page,
          size: this.testPaperList.size
        });
        this.$message.success("删除成功");
      });
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.TestPaperList {
  .tableFilter {
    padding-top: 20px;
    padding-bottom: 20px;

    .el-form-item {
      margin-right: 30px;
    }

    ::v-deep .el-range-separator {
      width: 20px !important;
    }
  }
}
</style>
